import { useStore } from "@/context/StoreContext";

const Diamond = () => (
  <span className="mx-8 inline-block h-1.5 w-1.5 rotate-45 bg-ember" aria-hidden="true" />
);

export default function Marquee() {
  const { t } = useStore();
  const items = [...t.marquee, ...t.marquee, ...t.marquee];

  return (
    <div
      data-testid="marquee-strip"
      className="relative overflow-hidden border-y border-white/10 bg-ink-soft py-5"
    >
      <div className="animate-marquee flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center" aria-hidden={half === 1}>
            {items.map((text, i) => (
              <span
                key={`${half}-${i}`}
                className="flex items-center whitespace-nowrap font-display text-sm font-bold uppercase tracking-[0.35em] text-zinc-400"
              >
                {text}
                <Diamond />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
